

















































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import dialogNewBoletoEspecial from '@/components/dialogNewBoletoEspecial.vue'
import dialogViewBoletoEspecialSolicitado from '@/components/dialogViewBoletoEspecialSolicitado.vue'
import { BoletoEspecialDTO } from '@/interfaces/BoletoEspecial.interface'
import HTTP from '@/plugins/axios'
import { TextMSGDTO } from '@/interfaces/DialogNewRolUsuario.interface'

@Component ({
  components: {
    dialogNewBoletoEspecial,
    dialogViewBoletoEspecialSolicitado
  }
})
export default class ViewBoletosEspeciales extends Vue {
  private name: string = 'ViewBoletosEspeciales'

  private dialog: boolean = false
  private tab: number = 1
  private infoBoletoEspecial: BoletoEspecialDTO = null
  private updateBoletoEspecial: boolean = false
  private infoBoletosEspeciales: BoletoEspecialDTO[] = []
  private infoBoleto: object = {}
  private infoDescuento: object = {}
  private patrocinadorSeleccionado: BoletoEspecialDTO = null

  private headersCortesias = [
    {
      text: 'Fecha',
      align: 'left',
      sortable: false,
      value: 'createdAt',
    },
    { text: 'Nombre', value: 'solName' },
    { text: 'Email', value: 'solEmail' },
    { text: 'Folio', value: 'folio' },
    { text: 'Folio Encriptado', value: 'folioEncrypted' },
    { text: 'Acciones', value: 'acciones' }
  ]

  private tableCortesias: any[] = []

  private infoDescuentos: any[] = [
    {
      name: 'Persona 1',
      categoriaBoleto: [
        'Adulto', 'Infantil'
      ],
      boletos: [
        'Folio: 2000000001',
        'Folio: 2000000002',
        'Folio: 1000000001',
      ],
      email: 'persona1@hotmail.com',
      fecha: '09/21/2019',
      cantidad: 3,
      status: 'Desbloqueado'
    },
    {
      name: 'Persona 2',
      categoriaBoleto: [
        'Infantil'
      ],
      boletos: [
        'Folio: 2000000001',
        'Folio: 2000000002',
      ],
      email: 'persona2@hotmail.com',
      fecha: '09/22/2019',
      cantidad: 2,
      status: 'Desbloqueado'
    },
    {
      name: 'Persona 3',
      boletos: [
        'Folio: 2000000001',
        'Folio: 2000000002',
        'Folio: 2000000001',
        'Folio: 2000000002',
        'Folio: 2000000001',
      ],
      categoriaBoleto: [
        'Adulto', 'Infantil'
      ],
      email: 'persona3@hotmail.com',
      fecha: '09/23/2019',
      cantidad: 5,
      status: 'Desbloqueado'
    }
  ]

  private headersBoletoEspecial: any[] = [
      {
        text: 'Nombre',
        align: 'left',
        sortable: true,
        value: 'name'
      },
      { text: 'Folio Inicial', value: 'folioBeg' },
      { text: 'Folio Final', value: 'folioEnd' },
      { text: 'Total', value: 'total' },
      { text: 'Responsable', value: 'respName' },
      { text: 'Solicitados', value: 'solicitados' },
      { text: 'Acciones', value: 'acciones' }
    ]

  private headerSolicitados: any[] = [
    {
      text: 'Nombre',
      align: 'left',
      sortable: true,
      value: 'solName'
    },
    { text: 'Email', value: 'solEmail' },
    { text: 'Folio', value: 'folio' },
    { text: 'Fecha Solicitud', value: 'createdAt' },
    { text: 'Acciones', value: 'acciones' }
  ]

  private textMSG: TextMSGDTO = {
    block: {
      text: 'Boleto Especial Bloqueado:',
      color: 'info'
    },
    delete: {
      text: 'Boleto Especial Eliminado:',
      color: 'info'
    },
    fail: {
      text: 'Error al bloquear un boleto especial:',
      color: 'error'
    },
  }

  @Watch('updateBoletoEspecial')
  private watchUpdateBoletoEspecial (v: boolean) {
    if (v) {
      this.gBoletoEspecial()
    }
  }

  @Watch('patrocinadorSeleccionado')
  private watchPatrocinadorSeleccionado (v: BoletoEspecialDTO) {
    if (v !== null) {
      console.log('watchPatrocinadorSeleccionado :: NOT NULL', v)
      this.tableCortesias = v.solicitados
    } else {
      console.log('watchPatrocinadorSeleccionado :: NULL', v)
    }
  }

  private viewBoletoEspecial (item: any) {
    this.infoBoletoEspecial = Object.assign({}, item)
    // this.actionBoleto = 'edit'
  }

  private gBoletoEspecial () {
    HTTP.get('boleto-especial/')
      .then((response) => {
        console.log('gBoletoEspecial :: response :: ', response.data)
        this.infoBoletosEspeciales = response.data
      })
      .catch((e) => {
        console.log('gBoletoEspecial :: catch :: ', e.response.data)
      })
  }

  private block (item: any) {
    HTTP.get('boleto-especial/' + item.id + '/block')
      .then((response) => {
        console.log('block :: response :: ', response.data)
        this.gBoletoEspecial()
        this.$store.commit('setSnackbarMsg',  {
          text: this.textMSG.block.text + ' ' + item.name,
          color: this.textMSG.block.color,
          show: true,
          timeout: 2000
        })
      })
      .catch((e) => {
        console.log('block :: catch :: ', e.response.data)
        this.$store.commit('setSnackbarMsg',  {
          text: this.textMSG.fail.text + ' ' + item.name,
          color: this.textMSG.fail.color,
          show: true,
          timeout: 2000
        })
      })
  }

  private deleteBoletoEspecial (item: any) {
    HTTP.delete('boleto-especial/' + item.id)
      .then((response) => {
        console.log('delete :: response :: ', response.data)
        this.gBoletoEspecial()
        this.$store.commit('setSnackbarMsg',  {
          text: this.textMSG.block.text + ' ' + item.name,
          color: this.textMSG.block.color,
          show: true,
          timeout: 2000
        })
      })
      .catch((e) => {
        console.log('delete :: catch :: ', e.response.data)
        this.$store.commit('setSnackbarMsg',  {
          text: this.textMSG.fail.text + ' ' + item.name,
          color: this.textMSG.fail.color,
          show: true,
          timeout: 2000
        })
      })
  }

  private reSendEmail (id: string) {
    HTTP.get('boleto-especial/' + id + '/resend-email')
      .then((response) => {
        console.log('reSendEmail :: response :: ', response.data)
        this.$store.commit('setSnackbarMsg',  {
          text: 'El email ha sido, re-enviado.',
          color: 'success',
          show: true,
          timeout: 2000
        })
      })
      .catch((e) => {
        console.log('reSendEmail :: catch :: ', e.response.data)
      })
  }

  private viewPDF (id: string) {
    HTTP.get('boleto-especial/' + id + '/view-pdf-cortesia')
      .then((response) => {
        console.log('viewPDF :: response :: ', response.data)
        window.open(process.env.VUE_APP_AXIOS_BASE_URL + 'conekta/pdf/' + response.data, '_blank')
      })
      .catch((e) => {
        console.log('viewPDF :: catch :: ', e.response.data)
      })
  }

  private gBoletoEspecialSolicitados (item: any) {
    console.log('item')
  }

  private beforeMount () {
    console.log('beforeMount :: ', this.name)
    this.gBoletoEspecial()
  }
}
